import React from 'react'
import { Icon } from './icons'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

// Appraisal form Zap. Zapier maps the email "To" and "Subject" from the
// `recipient` and `subject` fields sent with each submission.
const ZAPIER_HOOK = 'https://hooks.zapier.com/hooks/catch/3298056/4hpyt15/'

const FORM_ROUTING = {
  'Sales Appraisal': {
    subject: 'Sales Appraisal Inquiry',
    recipient: 'corene@corerealty.com.au, reception@corerealty.com.au',
  },
  'Rental Appraisal': {
    subject: 'Rental Appraisal Inquiry',
    recipient: 'elsa@corerealty.com.au, reception@corerealty.com.au',
  },
  // Generic form (mobile menu) has no sales/rental context, so everyone gets it.
  'Property Appraisal': {
    subject: 'Property Appraisal Inquiry',
    recipient: 'reception@corerealty.com.au, corene@corerealty.com.au, elsa@corerealty.com.au',
  },
}

const getFormType = (location, appraisal_type) => {
  if (location?.pathname?.indexOf('/property/') > -1) return 'Sales Appraisal'
  if (location?.pathname?.indexOf('/rental/') > -1) return 'Rental Appraisal'
  if (FORM_ROUTING[appraisal_type]) return appraisal_type
  return 'Property Appraisal'
}

const AppraisalForm = ({ id, location, appraisal_type = null, heading = 'Request a Property Appraisal' }) => {

  const [state, setState] = React.useState({})
  const [result, setResult] = React.useState('')
  const formRef = React.useRef()

  React.useEffect(() => {
    const type = getFormType(location, appraisal_type)

    setState(state => { 
      return { ...state, appraisal_type: type }
    })
  }, [location?.pathname, appraisal_type])

  const handleChange = e => {
    setState({ ...state, [e.target.name]: e.target.value })
  }

  const handleSubmit = e => {
    e.preventDefault()

    if (!formRef.current?.checkValidity()) return false

    const formType = getFormType(location, appraisal_type)
    const routing = FORM_ROUTING[formType]

    fetch(ZAPIER_HOOK, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": formRef.current.getAttribute("name"),
        form_type: formType,
        subject: routing.subject,
        recipient: routing.recipient,
        ...state
      })
    })
      .then(() => {
        setResult('success')
      })
      .catch(error => setResult('fail'))
  }

  let props = {
    ref: formRef,
    name: 'appraisal',
    className: 'form',
    onSubmit: handleSubmit,
  }

  if (result === 'success') {
    return (
      <div className='contact__success'>
        <Icon />
        <h4>Thank you</h4>
        <p>We’ll be in touch with you shortly.</p>
      </div>
    )
  }

  return (
    <form {...props}>
      <h4>{heading}</h4>
      <div className='form__row'>
        <label htmlFor={`${id}_sales_appraisal`}>Type of appraisal required</label>
        <div className='form__radios'>
          <div className='form__radio'>
            <input id={`${id}_residential_appraisal`} type='radio' name="appraisal_type" onChange={handleChange} value="Residential" />
            <label htmlFor={`${id}_residential_appraisal`}>Residential</label>
          </div>
          <div className='form__radio'>
            <input id={`${id}_commercial_appraisal`} type='radio' name="appraisal_type" onChange={handleChange} value="Commercial" />
            <label htmlFor={`${id}_commercial_appraisal`}>Commercial</label>
          </div>
        </div>
      </div>
      <div className='form__row form__row--double'>
        <div className='form__column'>
          <label htmlFor={`${id}_first-name-field`}>First Name</label>
          <input className='form__input' type='text' name='firstname' id={`${id}_first-name-field`} placeholder='-' onChange={handleChange} required />
        </div>
        <div className='form__column'>
          <label htmlFor={`${id}_last-name-field`}>Last Name</label>
          <input className='form__input' type='text' name='lastname' id={`${id}_last-name-field`} placeholder='-' onChange={handleChange} required />
        </div>
      </div>
      <div className='form__row'>
        <label htmlFor={`${id}_email-field`}>Contact Email</label>
        <input className='form__input' type='email' name='email' id={`${id}_email-field`} placeholder='-' onChange={handleChange} required />
      </div>
      <div className='form__row'>
        <label htmlFor={`${id}_phone-field`}>Contact Number</label>
        <input className='form__input' type='text' name='mobile' id={`${id}_phone-field`} placeholder='-' onChange={handleChange} required />
      </div>
      <div className='form__row'>
        <label htmlFor={`${id}_addres-field`}>Enter address of property to be appraised</label>
        <input type='text' name='address' id={`${id}_address-field`} placeholder='-' onChange={handleChange} required />
      </div>
      <div className='form__row'>
        <label htmlFor={`${id}_message`}>Additional Comments (optional)</label>
        <textarea className='form__input form__textarea' id={`${id}_message`} name='message' placeholder='-' onChange={handleChange} />
      </div>
      <div className='form__row form__row--submit'>
        <button type='submit' className='btn btn--border'>Request Appraisal</button>
      </div>
    </form>
  )
}

export default AppraisalForm